import { useMemo } from 'react';
import {
  ServiceInfo,
  ServiceInfoFromBack,
} from '../../types/serviceInfo.types';
import { CreateServiceInfoModal } from './modals/CreateServiceInfoModal';
import { EditServiceInfoModal } from './modals/EditServiceInfoModal';
import { EditServiceInfoPricesModal } from './modals/EditServiceInfoPricesModal/EditServiceInfoPricesModal';
import { ServiceHubModal } from './modals/ServiceHub/ServiceHubModal';
import { DeleteServiceInfoModal } from './modals/DeleteServiceInfoModal/DeleteServiceInfoModal';

export enum MODALS {
  CREATE_SERVICE_INFO = 'CREATE_SERVICE_INFO',
  EDIT_SERVICE_INFO = 'EDIT_SERVICE_INFO',
  EDIT_SERVICE_INFO_PRICES = 'EDIT_SERVICE_INFO_PRICES',
  CREATE_SERVICE_HUB = 'CREATE_SERVICE_HUB',
  DELETE_SERVICE_HUB = 'DELETE_SERVICE_HUB',
}

export type ModalKeys = keyof typeof MODALS;

interface chooseModalProps {
  choosenModal: ModalKeys | null;
  selectedGadgetId: string;
  selectedServiceInfo: ServiceInfo | null;
  closeModal: () => void;
  updateAfterAdd: (serviceInfo: ServiceInfoFromBack) => void;
  updateAfterEdit: (serviceInfo: ServiceInfoFromBack) => void;
  updateDelete: (id: string, gadgetId: string) => void;
}

export const ChooseModal = ({
  selectedServiceInfo,
  updateAfterEdit,
  updateDelete,
  updateAfterAdd,
  closeModal,
  selectedGadgetId = '',
  choosenModal,
}: chooseModalProps) => {
  const modal = useMemo(() => {
    switch (choosenModal) {
      case MODALS.CREATE_SERVICE_INFO:
        return (
          <CreateServiceInfoModal
            updateAfterCreating={updateAfterAdd}
            selectedGadgetId={selectedGadgetId}
            open
            onClose={closeModal}
          />
        );
        case MODALS.CREATE_SERVICE_HUB:
        return (
          <ServiceHubModal
            open
            onClose={closeModal}
            selectedServiceInfoId={selectedServiceInfo?.id}
          />
        );
      case MODALS.EDIT_SERVICE_INFO: {
        return (
          selectedServiceInfo && (
            <EditServiceInfoModal
              open
              updateAfterEditing={updateAfterEdit}
              selectedServiceInfo={selectedServiceInfo}
              onClose={closeModal}
            />
          )
        );
      }
      case MODALS.DELETE_SERVICE_HUB: {
        return (
          selectedServiceInfo && (
            <DeleteServiceInfoModal
              open
              updateDelete={updateDelete}
              id={selectedServiceInfo.id as string}
              gadgetId={selectedGadgetId}
              onClose={closeModal}
            />
          )
        );
      }
      case MODALS.EDIT_SERVICE_INFO_PRICES: {
        return (
          selectedServiceInfo && (
            <EditServiceInfoPricesModal
              open
              selectedServiceInfoId={selectedServiceInfo.id}
              onClose={closeModal}
            />
          )
        );
      }
      default:
        return <></>;
    }
  }, [choosenModal, closeModal, selectedGadgetId]);

  return modal;
};
